import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useState, useEffect, useCallback, useRef } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Form, FormElement } from "@progress/kendo-react-form";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { RadioGroup } from "@progress/kendo-react-inputs";
import { TextArea } from "@progress/kendo-react-inputs";
import { FILES_CONTEXT, useFiles } from "services/filesDownloadService";
import * as api from "../../api/index";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import PaySupplierGrid from "./PaySupplierGrid";
import SearchComboBox from "components/common/SearchComboBox";
import CONSTANT from "CONSTANT/Matter/ComboxType";
import { toast } from "react-toastify";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { TransactionPeriod } from "components/common/TransactionPeriod";
import SubmitButton from "components/common/SubmitButton";
import styles from "./PaySupplier.module.scss";

const typeData = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Disbursements",
    value: "disbursements",
  },
  {
    label: "Purchase Invoices",
    value: "invoices",
  },
];

const PaySupplier = ({ is_type, preSelectedData, preSelectedSupplier, onClose }) => {
  const date = new Date();
  const formRenderPropsRef = useRef(null);

  const [initialData] = useState({
    date: new Date(Date.now()),
    supplierRef: preSelectedSupplier || undefined,
    officeBank: undefined,
  });

  const [details, setDetails] = useState("");
  const [reference, setReference] = useState("");
  const [data, setData] = useState(preSelectedData?.length ? preSelectedData : []);
  const [payee, setPayee] = useState("");
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("all");
  const [dateselector, setdateselector] = useState(date);
  const [supplierRef, setSupplierRef] = useState(preSelectedSupplier?.supplierRef);
  const [allocation, setAllocation] = useState(null);
  const [isSupplierLocked, setIsSupplierLocked] = useState(!!preSelectedSupplier);
  const [validationAttempted, setValidationAttempted] = useState(false);

  const { files: filesCurrentData, clearDisbursementFiles } = useFiles(
    FILES_CONTEXT.DISBURSEMENT_PAYMENT
  );

  const getSupplierData = async (supplierRef) => {
    if (supplierRef) {
      let transactiontype = type;
      if (type === "all") transactiontype = undefined;
      const datas = await api.getPaySupplierList(
        supplierRef,
        transactiontype,
        is_type
      );
      datas?.data?.data.forEach((element) => {
        element.inEdit = true;
        element.add = false;
        element.amount = 0;
      });
      setData(datas?.data?.data);
    } else {
      setData([]);
    }
  };

  const onChangeSupplier = async (event) => {
    if (isSupplierLocked) return;
    try {
      getSupplierData(event?.value?.supplierRef);
      setSupplierRef(event?.value?.supplierRef);
      setPayee(event?.value?.payeeName);
    } catch (error) {
      console.error(error);
    }
  };
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  useEffect(() => {
    if (supplierRef && !isSupplierLocked) {
      getSupplierData(supplierRef);
    }
  }, [type]);

  const handleUpdateAllocations = useCallback((value) => {
    setAllocation(value);
  }, []);

  const handleSetAmount = useCallback(() => {}, []);

  async function Submithandler(value) {
    if (
      !value?.supplierRef ||
      !value?.officeBank ||
      !reference ||
      !payee ||
      !details
    ) {
      setValidationAttempted(true);
      return;
    }

    const payload = [
      {
        postingType: "SUP",
        supplierRef: value?.supplierRef?.supplierRef,
        date: dateselector,
        netAmount: amount,
        transactionPeriod: 202201,
        currencyCode: "GBP",
        details,
        reference,
        Payee: payee,
        OfficeBank: value?.officeBank?.nominalRef,
      },
    ];

    if (Array.isArray(allocation)) {
      const totalAllocatedAmount = allocation.reduce(
        (sum, item) => sum + (item.amount || 0),
        0
      );

      if (totalAllocatedAmount !== amount) {
        toast.error("Allocated amount should be equal to net amount");
        return;
      }

      payload[0].allocations = allocation;
    }

    if (Array.isArray(filesCurrentData) && filesCurrentData.length > 0) {
      payload[0].DocumentFiles = filesCurrentData.map((item) => item.fileID);
    }

    setLoading(true);

    try {
      const response = await api.createposting(payload);
      const isSuccess = response?.status === 200 || response?.status === 201;

      if (isSuccess) {
        const responseData = response?.data?.data?.[0];
        const transactionNo = responseData?.transactionNo;
        const detailMsg = responseData?.details || "Transaction successful";

        const message = transactionNo
          ? `${detailMsg} (Transaction No: ${transactionNo})`
          : detailMsg;
        toast.success(message);

        setValidationAttempted(false);
        if (!isModalMode && supplierRef) {
          await reset();
        }
        if (isModalMode && onClose) {
          onClose();
        }
      }
    } catch (error) {
      const message = error?.response?.data?.errorMessage || "Transaction failed";
    }
    setLoading(false);
  }
  const reset = async () => {
    setDetails("");
    setAmount(0);
    setPayee("");
    setReference("");
    setdateselector(new Date());
    setValidationAttempted(false);
    setAllocation(null);
    formRenderPropsRef.current?.onChange?.("officeBank", { value: null });
    await getSupplierData(supplierRef);
    clearDisbursementFiles();
    setFilesData([]);
  };

  const { uploadForm, progress } = useUploadForm();

  const [filesData, setFilesData] = useState([]);

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);

    const parameters = {
      documentType: "Posting",
      supplierRef: supplierRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
  };

  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  const isModalMode = !!onClose;

  return (
    <div
      className={`d-flex ps-0 ms-0 g-0 flex-column h-100 ${isModalMode ? "" : "pb-3 h-100"
        }`}>
      <div
        className="d-flex flex-grow-1 pb-3"
        style={{ overflow: "hidden", minHeight: 0 }}>
        <div
          className="bgForm h-100 ms-2 pt-4 d-flex justify-content-center align-item-center"
          style={{
            minWidth: "350px",
            maxWidth: "350px",
            overflow: "auto",
          }}>
          <div className="w-100 px-4">
            <Form
              ignoreModified={true}
              onSubmit={Submithandler}
              initialValues={initialData}
              id="disbform"
              render={(formRenderProps) => {
                formRenderPropsRef.current = formRenderProps;
                const supplierValue = formRenderProps.valueGetter("supplierRef");
                const officeBankValue = formRenderProps.valueGetter("officeBank");

                return (
                  <FormElement name="disbform" id="disbform" noValidate>
                    <fieldset>
                      <div className="mb-3">
                        <SearchComboBox
                          name="supplierRef"
                          cbType={is_type ? CONSTANT.CR : CONSTANT.SR}
                          controlled={true}
                          onChangeFunction={onChangeSupplier}
                          width="auto"
                          boxShadow={true}
                          readOnly={isSupplierLocked}
                          error={validationAttempted && !supplierValue}
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="label">Date</Label>
                        <DatePicker
                          className={`${styles["showdow"]} px-1`}
                          value={dateselector}
                          onChange={onChangedateselect}
                          toggleButton={CalenderCustomToggleButton}
                        />
                      </div>
                      <div className="mb-3">
                        <SearchComboBox
                          name="officeBank"
                          cbType={CONSTANT.OB}
                          controlled={true}
                          width="auto"
                          boxShadow={true}
                          error={validationAttempted && !officeBankValue}
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="label">Reference</Label>
                        <Input
                          width={200}
                          value={reference}
                          onChange={(e) => {
                            setReference(e.target.value);
                          }}
                          className={`${styles["showdow"]}`}
                          style={{
                            border:
                              validationAttempted && !reference
                                ? "1px solid red"
                                : undefined,
                          }}
                        />
                      </div>
                      <div className="mb-3 right-align">
                        <Label className="label">Amount</Label>
                        <NumericTextBox
                          style={{
                            textAlign: "right",
                            boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 16px",
                          }}
                          value={amount}
                          onChange={(e) => {
                            setAmount(e.target.value);
                          }}
                          placeholder="0.00"
                          spinners={false}
                          format="n2"
                        />
                      </div>

                      <div className="mb-3">
                        <Label className="label">Payee</Label>
                        <Input
                          name="payee"
                          width={200}
                          value={payee}
                          onChange={(e) => {
                            setPayee(e.target.value);
                          }}
                          className={`${styles["showdow"]}`}
                          style={{
                            border:
                              validationAttempted && !payee
                                ? "1px solid red"
                                : undefined,
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <Label className="label">Details</Label>

                        <TextArea
                          rows={4}
                          placeholder="Enter Details"
                          value={details}
                          onChange={(e) => {
                            setDetails(e.target.value);
                          }}
                          className={`${styles["showdow"]}`}
                          style={{
                            border:
                              validationAttempted && !details
                                ? "1px solid red"
                                : undefined,
                          }}
                        />
                      </div>
                      <div className="d-flex justify-content-end">
                        <DocumentsUpload
                          progress={progress}
                          filesData={filesData}
                          onFileRemove={onFileRemove}
                          onUpload={handleUpload}
                          onError={() => {
                            const newFiles = filesData.splice(filesData.length, 1);
                            setFilesData([...newFiles]);
                          }}
                          type={"DUP"}
                        />
                      </div>
                      <button
                        id="submit-button-supplier"
                        type="button"
                        style={{ visibility: "hidden" }}
                        onClick={() => {
                          setValidationAttempted(true);
                          formRenderProps.onSubmit();
                        }}></button>
                    </fieldset>
                  </FormElement>
                );
              }}
            />
          </div>
        </div>

        <div className="flex-grow-1 overflow-auto h-100 d-flex flex-column">
          <TransactionPeriod />

          <div
            className="mx-3 mt-3 h-100 d-flex flex-column"
            style={{ minHeight: "110px" }}>
            {!is_type && (
              <RadioGroup
                className="radio mb-3 me-3 ms-auto"
                layout="horizontal"
                data={typeData}
                value={type}
                onChange={(e) => setType(e.value)}
              />
            )}

            <PaySupplierGrid
              updateAllocations={handleUpdateAllocations}
              setAmount={handleSetAmount}
              type={type}
              data={data}
            />
            {!isModalMode && (
              <div className="buttonstyle justify-content-end">
                <SubmitButton
                  form="disbform"
                  type="button"
                  isLoading={loading}
                  onClick={() =>
                    document.getElementById("submit-button-supplier").click()
                  }>
                  Post
                </SubmitButton>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalMode && (
        <div className="dialog-footer d-flex justify-content-end gap-2 me-3">
          <Button
            className={`k-button common-btn bgBtnSecondary me-1`}
            onClick={onClose}>
            Cancel
          </Button>
          <SubmitButton
            form="disbform"
            type="button"
            isLoading={loading}
            onClick={() =>
              document.getElementById("submit-button-supplier").click()
            }>
            Post
          </SubmitButton>
        </div>
      )}
    </div>
  );
};
export default PaySupplier;
